import { useState, useEffect } from 'react';
import AddIcon from '@material-ui/icons/Add';
import { Title } from '../../../component/title/Title';
import Modal from '../../../component/modal/Modal.component';
import GridComponent from '../../../component/grid/GridComponent.component';
import { deleteComponent, putComponent, postComponent } from './Component.service';
import Form from './form/Form.component';
import Table from '../../../component/table/Table.component';
import { ACTION_DELETE, Action, ACTION_EDIT_SUBMIT } from '../../../component/table/interfaces/TableInterface';
import ModalDelete from '../../../component/modal/ModalDelete.component';
import { useSnackbar } from '../../../context/Snackbar';
import Component from './interfaces/Component';
import useModal from '../../../hooks/useModal';
import ParamTypes from '../../../core/interfaces/ParamTypes';
import { useParams } from 'react-router-dom';
import { getByFunctionality } from '../functionality/Functionality.service';
import { HEAD_CELL } from './utils/HEAD_CELL';
import { getTypeComponent } from '../Security.service';
import ComponentType from './interfaces/ComponentType';
import Functionality from '../functionality/interfaces/Functionality';

export default function ComponentComponent() {

    let { id } = useParams<ParamTypes>();
    const [open, addModal] = useModal();
    const { setSnackbar } = useSnackbar();
    const [functionality, setFunctionality] = useState<Functionality>();
    const [componentType, setComponentType] = useState<ComponentType[]>([]);
    const [request, setRequest] = useState<boolean>(true);

    useEffect(() => {
        getTypeComponent().then(res => {
            setComponentType(res.data.data);
        }).catch((error) => {
            console.log('Erro ao consultar tipo de componente', error);
        });
    }, []);

    useEffect(() => {
        getByFunctionality(Number(id)).then(res => {
            setFunctionality(res.data[0]);
        }).catch((error) => {
            console.log('Erro ao consultar funcionalidade', error);
        }).finally(() => {
            setRequest(false);
        });
    }, [id, request]);

    const registerComponent = async (component: Component) => {
        component.funcionalidade_id = Number(id);
        try {
            await (component.id ? putComponent(component) : postComponent(component));
            setSnackbar({ msg: `componente foi ${component.id ? 'atualizado' : 'cadastrado'} com sucesso!`, type: 'success' });
            addModal(false);
            setRequest(true);
        } catch (error) {
            console.log('Erro ao submeter componente!', error);
            setSnackbar({ msg: `Erro ao ${component.id ? 'atualizar' : 'cadastrar'} componente!`, type: 'error' });
        }
    }

    const handleClickAction = (action: Action, component: Component) => {
        if (action === ACTION_EDIT_SUBMIT) {
            return registerComponent(component);
        }
        if (action === ACTION_DELETE) {
            return addModal(component.id);
        }
    };

    const handleClickDelete = async () => {
        await deleteComponent(Number(open)).then(res => {
            setSnackbar({ msg: "componente excluído com sucesso!", type: 'success' });
            setRequest(true);
        }).catch(error => {
            console.log('Erro ao excluir componente!', error);
            setSnackbar({ msg: "Erro ao excluir componente!", type: 'error' });
        }).finally(function () {
            addModal(undefined);
        });
    };

    return (
        <>
            <GridComponent>
                <Title>FUNCIONALIDADE: &nbsp;</Title>
                {functionality?.nome}
            </GridComponent>
            <br />
            <GridComponent justify="space-between">
                <Title>COMPONENTE</Title>

                <Modal title="Criar Componente" open={open === true} handleClick={() => addModal(!open)} icon={<AddIcon />} >
                    <Form handleClick={() => addModal(false)} handleSubmitForm={registerComponent} request={request} componentType={componentType} />
                </Modal>
            </GridComponent>
            <ModalDelete open={!!open && open !== true} handleClick={() => addModal(undefined)} onClickSubmit={handleClickDelete} title="Confirma a exclusão desse componente?" />
            <br />
            <br />
            <Table
                request={request}
                data={functionality ? functionality.componentes || [] : []}
                headCells={HEAD_CELL}
                editable
                noActionView
                handleClickAction={handleClickAction}
            />
        </>
    );
}
